import { NewCalfEntryInputExtended } from '@/components/pages/CalfEntry/types';

export const initialRequirementsState = {
  receivedDate: new Date(),
  owner: null,
  herdsman: null,
};

export const initialCalfEntryState = {
  requirements: initialRequirementsState,
  calves: [],
};

export const initialCalfState: NewCalfEntryInputExtended = {
  birth: null,
  breed: null,
  breedId: null,
  col1FeedingAmount: '',
  col1FeedingDate: null,
  col1FeedingTime: null,
  col2FeedingAmount: '',
  col2FeedingDate: null,
  col2FeedingTime: null,
  comments: '',
  ddEntryDate: null,
  navelStatus: null,
  pen: null,
  penId: null,
  registry: '',
  sex: null,
  tag: '',
  temp: null,
  testiclesDecendedOn: null,
  testicularDevelopment: null,
  weight: null,
  yardId: null,
};
